import Vue from "vue";
import Router from "vue-router"; // 引入router
import Cookies from 'js-cookie';
import staticRouter from "./router"; // 引入router.js文件

Vue.use(Router); // 注册路由插件

const router = new Router({
  mode: 'history', // 去掉url中的#
  
  routes: staticRouter,
});

router.beforeEach((to, from, next) => {
  let token = Cookies.get('userToken'); // 获取名为key的cookie的值
  if (to.path !== '/login' && (!token || token === 'undefined' || token === 'null')) {
    // next('/login'); // 未登录跳转到登录页
    const baseUrl = process.env.VUE_APP_BASE_URL_LOGIN || "";
    location.href = `${baseUrl}/html`;
  } else {
    next(); // 已登录跳转到目标页面
  }
});

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

export default router;